// Customer-facing copy for prepaid SmartSpectra Premium. Source of truth:
// presage-usage docs/superpowers/specs/2026-10-13-premium-prepay-extra-usage-design.md
// ($20/month billed upfront, 3,000 credits = 25 hours, resets at renewal, hard stop at 0).
export const PREMIUM_PRICE_LABEL = "$20 / month, billed upfront";
export const PREMIUM_INCLUDED_LABEL = "25 hours of measurement each month (3,000 credits)";
export const PREMIUM_RESET_LABEL = "Resets every renewal. Usage pauses at 0.";
export const ALREADY_SUBSCRIBED_MESSAGE =
  "Your Premium subscription is already active. It can take a minute to show here — refresh shortly, or open Manage Billing.";

const COMP_PREMIUM_LABEL = "Premium (complimentary)";
const PAID_TIERS = ["Premium", "Essentials", COMP_PREMIUM_LABEL];

// Display names for tier_name values that should not just be capitalised.
// premium_comp is a non-Stripe comp tier: Premium's hours, refilled monthly, no billing.
const TIER_LABELS = { premium_comp: COMP_PREMIUM_LABEL };

export function tierLabel(tierName) {
  if (!tierName) return tierName;
  return TIER_LABELS[tierName] ?? tierName.charAt(0).toUpperCase() + tierName.slice(1);
}

export function isPaidTier(tierLabel) {
  return PAID_TIERS.includes(tierLabel);
}

export function creditTooltip(remaining, total, nextRenewal) {
  if (typeof remaining !== "number" || typeof total !== "number") return "";
  if (Number.isNaN(remaining) || Number.isNaN(total)) return "";
  const low = remaining <= 0 || (total > 0 && remaining / total < 0.1);
  if (low) {
    return `Your included hours reset on ${nextRenewal}. Usage pauses when you run out.`;
  }
  return "You are using credits within your current tier.";
}

export function pausedMessage(nextRenewal) {
  return `Paused: your hours reset on ${nextRenewal}`;
}

export function isPaused(tierLabel, includedCredits, extraCredits = 0) {
  if (!isPaidTier(tierLabel)) return false;
  if (typeof includedCredits !== "number" || Number.isNaN(includedCredits)) return false;
  return includedCredits + (Number(extraCredits) || 0) <= 0;
}
